import { assign, freeze } from 'icepick';
import { defaultLocale } from '@jira/platform__supported-locales/src/supported-locales.tsx';
import { SET_APP_PROPS, type SetAppPropsAction } from '../actions/app-props.tsx';
import type { ContextState } from './types.tsx';

type Action = SetAppPropsAction;

export const initialState: ContextState = freeze({
	id: '',
	name: '',
	locale: defaultLocale,
	projectKey: '',
	analyticsData: {
		projectType: '',
	},
	relatedIssueCount: 0,
	relatedIssueUrl: '',
});

const context = (state: ContextState = initialState, action: Action): ContextState => {
	switch (action.type) {
		case SET_APP_PROPS: {
			return assign(state, action.payload.context);
		}
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};

export default context;
